<section class="summary" *ngIf="summary">
    <h3 class="summary-title">Detalles de la propiedad</h3>
    <div class="summary-items">
        <div class="summary-item" *ngIf="summary.surface">
            <mat-icon>straighten</mat-icon>
            <span>{{ summary.surface }} m²</span>
        </div>
        <div class="summary-item" *ngIf="summary.rooms != null">
            <mat-icon>king_bed</mat-icon>
            <span>{{ summary.rooms }} hab.</span>
        </div>
        <div class="summary-item" *ngIf="summary.baths != null">
            <mat-icon>bathtub</mat-icon>
            <span>{{ summary.baths }} baños</span>
        </div>
    </div>
</section>
